export const normalizeToVar = (str: string) => {
  return str
    .trim() // remove leading/trailing spaces
    .replace(/[^a-zA-Z0-9_]/g, ' ') // replace non-English chars with empty space
    .replace(/\s+/g, '_') // replace 1+ spaces with underscore
    .toLowerCase(); // optional: make it lowercase
};
